import React from 'react';
import { getReactHtmlObject } from '../html-renderer';
import { PersistentTooltipCloseButton, PersistentTooltipContent, PersistentTooltipWrapper } from './style';

var PersistentTooltip = props => {
  var {
    onTooltipCloseButtonClick,
    tooltipContent,
    className,
    show
  } = props;

  var onTooltipClickHandler = e => {
    e.stopPropagation();
  };

  var onTooltipCloseButtonFocusHandler = e => {
    e.stopPropagation();
  };

  return /*#__PURE__*/React.createElement(PersistentTooltipWrapper, {
    show: show,
    className: className,
    onClick: onTooltipClickHandler
  }, /*#__PURE__*/React.createElement(PersistentTooltipContent, {
    dangerouslySetInnerHTML: getReactHtmlObject(tooltipContent)
  }), onTooltipCloseButtonClick && /*#__PURE__*/React.createElement(PersistentTooltipCloseButton, {
    size: 16,
    icon: 'CloseCircle',
    onFocus: onTooltipCloseButtonFocusHandler,
    onClick: onTooltipCloseButtonClick
  }));
};

export default PersistentTooltip;